import React, { Fragment, useEffect, useState } from 'react';
import DatagridGroup from '../../../table/DatagridGroup';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { translate } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import * as _ from 'lodash';
import DataGridHeaderCW from '../../../table/DataGridHeaderCW';
import DataGridGroupCW from '../../../table/DataGridGroupCW';

function TblCW({ t, partSnap, typeIndex }) {
  const [isPc, setIsPc] = useState(false);
  const [heightTb, setHeightTb] = useState(360);

  useEffect(() => {
    const heightTb = 360 - (typeIndex === 1 ? 0 : typeIndex === 2 ? 100 : 145);
    setHeightTb(heightTb);
  }, [typeIndex]);

  return (
    <Fragment>
      <div className="tbl-fix-header">
        <table className="table table-bordered table-fix">
          <colgroup>
            <col width="6%"/>
            <col width="3.9%"/>
            <col width="5.2%"/>
            <col width="2.5%"/>
            <col width="2.5%"/>
            <col width="2.5%"/>
            <col width="3.2%"/>
            <col width="3.2%"/>
            <col width="3.2%"/>
            <col width="3.2%"/>
            <col width="3.2%"/>
            <col width="3.2%"/>
            <col width="3.0%"/>
            <col width="3.3%"/>
            <col width="3%"/>
            <col width="3.2%"/>
            <col width="3.2%"/>
            <col width="3.2%"/>
            <col width="3.5%"/>
            <col width="3.2%"/>
            <col width="3.2%"/>
            <col width="3.1%"/>
            <col width="3.1%"/>
            <col width="4.2%"/>
            <col width="3%"/>
            <col width="3%"/>
            <col width="3.0%"/>
            <col width="3.5%"/>
          </colgroup>
          <thead className="bb-1-haft ">
            <DataGridHeaderCW
              isPc={isPc}
              setIsPc={setIsPc}
              t={t}
            />
          </thead>
        </table>
      </div>
      {!isMobile && (
        <PerfectScrollbar style={{ height: `calc(100vh - ${heightTb}px)` }}>
          <DataGridGroupCW
            resource={partSnap}
            className="table table-bordered table-fix"
            isPc={isPc}
          />
        </PerfectScrollbar>
      )}
      {isMobile && (
        <div
          style={{
            width: '100%',
            height: `calc(100vh - ${heightTb}px)`,
            overflowY: 'auto',
          }}
        >
          <DataGridGroupCW
            resource={partSnap}
            className="table table-bordered table-fix"
            isPc={isPc}
          />
        </div>
      )}
    </Fragment>
  );
}

export default translate('translations')(TblCW);
